<template>
	<div>
		<el-dialog :visible.sync="dialogVisible" width="698px" custom-class="login-dialog" @close="handleClose"
			:show-close="false" center :close-on-click-modal="false" destroy-on-close append-to-body>
			<div class="login-box">
				<div class="closebtn cur" @click="closedlg()">
					<i class="el-icon-close"></i>
				</div>
				<div class="left">
					<img src="@/static/login-bg.png" class="bg cover" />
				</div>
				<div class="right">
					<!-- 登录============================================== -->
					<div class="login-item" v-show="type==1">
						<div class="title vcenter">密码登录</div>
						<div class="login-form">
							<el-form ref="form" :rules="rules" :model="form" label-width="0">
								<el-form-item prop="username">
									<el-input v-model="form.username" maxlength="11" placeholder="请输入手机号码">
										<img slot="prefix" src="@/static/z-icon-tel.png" class="icon"></img>
									</el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input type="password" show-password v-model="form.password" placeholder="请输入密码">
										<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
									</el-input>
								</el-form-item>
								<el-form-item prop="vcode" class="elitem">
									<el-input v-model="form.vcode" placeholder="请输入验证码">
										<img slot="prefix" src="@/static/z-icon-vcode.png" class="icon"></img>
									</el-input>
									<img :src="codeImg" class="vcodeimg cur" @click="captcha()" title="点击刷新">
		
								</el-form-item>
		
							</el-form>
							<div class="policy"><el-checkbox v-model="checked">我已阅读并同意 <span class="cur curadm"
										@click.stop.prevent="text()">《服务条款》</span><span class="cur curadm"
										@click.stop.prevent="text()">《隐私政策》</span></el-checkbox></div>
							<div class="btn-box">
								<el-button :loading="loading1" :disabled="!checked" type="primary" class="green curadm" @click="onSubmit_login">登录</el-button>
							</div>
							<div class="vcenter toreg">
								<div class="align-c">
									<img src="@/static/z-icon-wx.png" class="kjlogin cur curadm" @click="tobind('wechart')"/>
									<img src="@/static/z-icon-zfb.png" class="kjlogin cur curadm" @click="tobind('alipay')"/>
									<a class="cur curadm" @click="type=3">忘记密码</a>
									<span>|</span>
									<a class="cur curadm" @click="type=2">免费注册</a>
								</div>
							</div>
		
		
						</div>
					</div>
		
					<!-- 注册============================================== -->
					<div class="register-item" v-show="type==2">
						<div class="title vcenter">用户注册</div>
						<div class="login-form">
							<el-form ref="form2" :rules="rules2" :model="form2" label-width="0">
								<el-form-item prop="mobile">
									<el-input v-model="form2.mobile" maxlength="11" placeholder="请输入手机号码">
										<img slot="prefix" src="@/static/z-icon-tel.png" class="icon"></img>
									</el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input v-model="form2.password" type="password" show-password
										placeholder="请输入6位以上的字母数字组合密码">
										<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
									</el-input>
								</el-form-item>
								<el-form-item prop="re_password">
									<el-input v-model="form2.re_password" type="password" show-password
										placeholder="请再次输入密码">
										<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
									</el-input>
								</el-form-item>
								<el-form-item prop="vcode" class="elitem">
		
									<el-input v-model="form2.vcode" placeholder="请输入验证码">
										<img slot="prefix" src="@/static/z-icon-vcode.png" class="icon"></img>
									</el-input>
									<el-button class="vcodebtn" :disabled="isCounting || !isPhoneValid"
										@click="handleGetCode">{{ buttonText }}</el-button>
		
		
								</el-form-item>
							</el-form>
							<div class="policy"><el-checkbox v-model="checked">我已阅读并同意 <span class="cur curadm"
										@click.stop.prevent="text()">《服务条款》</span><span class="cur curadm"
										@click.stop.prevent="text()">《隐私政策》</span></el-checkbox></div>
							<div class="btn-box">
								<el-button type="primary" :loading="loading2" :disabled="!checked" class="green curadm" @click="onSubmit_register">注册并登录</el-button>
							</div>
							<div class="tologin">已有账号？ <a class="cur curadm" @click="type=1">立即登录</a></div>
		
						</div>
					</div>
		
		
					<!-- 忘记密码============================================== -->
					<div class="register-item" v-show="type==3">
						<div class="title vcenter">忘记密码</div>
						<div class="login-form">
							<el-form ref="form3" :rules="rules3" :model="form3" label-width="0">
								<el-form-item prop="mobile">
									<el-input v-model="form3.mobile" maxlength="11" placeholder="请输入要找回密码的账号">
										<img slot="prefix" src="@/static/z-icon-tel.png" class="icon"></img>
									</el-input>
								</el-form-item>
		
								<el-form-item prop="vcode" class="elitem">
		
									<el-input v-model="form3.vcode" placeholder="请输入验证码">
										<img slot="prefix" src="@/static/z-icon-vcode.png" class="icon"></img>
									</el-input>
									<el-button class="vcodebtn" :disabled="isCounting3 || !isPhoneValid3"
										@click="handleGetCode3">{{ buttonText3 }}</el-button>
		
								</el-form-item>
		
								<el-form-item prop="new_password">
									<el-input v-model="form3.new_password" type="password" show-password
										placeholder="请输入新密码">
										<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
									</el-input>
								</el-form-item>
		
		
		
								<el-form-item prop="re_password">
									<el-input v-model="form3.re_password" type="password" show-password
										placeholder="请再次确认密码">
										<img slot="prefix" src="@/static/z-icon-pass.png" class="icon"></img>
									</el-input>
								</el-form-item>
		
							</el-form>
		
							<div class="btn-box">
								<el-button type="primary" :loading="loading3" class="green curadm" @click="onSubmit_reset">重置完成</el-button>
							</div>
							<div class="tologin"><a class="cur curadm" @click="type=1">返回登录</a></div>
		
						</div>
					</div>
		
		
				</div>
				
			</div>
		</el-dialog>
		<agreement ref="agreement" @agree="agree"></agreement>
	</div>
	
</template>

<script>
	import ty from "@/utils/ty/ty"
	import util from "@/common/util.js"
	import { mapMutations } from "vuex";
	import agreement from "@/components/agreement/agreement"
	export default {
		name: 'LoginDialog',
		components:{
			agreement
		},
		data() {
			return {
				type: 1,
				//dialogVisible: false,
				username:"",
				checked: false,
				loading1:false,
				loading2:false,
				loading3:false,
				codeImg:"",
				//密码登录
				form: {
					username: "13900000000",
					password: "Wy@123456",
					vcode: "",
				},


				//注册
				form2: {
					mobile: "",
					password: "",
					re_password: "",
					vcode: "",
				},



				//忘记密码
				form3: {
					mobile: "",
					vcode: "",
					new_password: "",
					re_password: "",
				},


				rules: {
					username: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (!util.checkPhone(value)) {
								callback(new Error('请输入正确的手机号码'));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
					vcode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, ],
				},

				rules2: {
					mobile: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!util.checkPhone(value)) {
									callback(new Error('请输入正确的手机号码'));
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
					re_password: [{
						required: true,
						message: '请再次输入密码',
						trigger: 'blur'
					}, ],
					vcode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, ],
				},

				rules3: {
					mobile: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => {
							if (!util.checkPhone(value)) {
								callback(new Error('请输入正确的手机号码'));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					vcode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, ],
					new_password: [{
						required: true,
						message: '请再次输入新密码',
						trigger: 'blur'
					}, ],
					re_password: [{
						required: true,
						message: '请再次确认密码',
						trigger: 'blur'
					}, ],
				},

				countdown: 60, // 注册倒计时秒数
				isCounting: false,

				countdown3: 60, // 忘记密码倒计时秒数
				isCounting3: false,

			};
		},
		watch: {
			type(newVal) {
				// 等待 DOM 更新（确保新表单已渲染，旧表单已销毁）
				this.$nextTick(() => {
					// 清除所有可能存在的表单验证
					['form', 'form2', 'form3'].forEach(refName => {
						const ref = this.$refs[refName];
						if (ref && typeof ref.clearValidate === 'function') {
							ref.clearValidate();
						}
					});
				});
			}
		},
		computed: {
			// 判断手机号是否合法（简单校验）
			isPhoneValid() {
				return util.checkPhone(this.form2.mobile);
			},
			// 按钮显示文字
			buttonText() {
				return this.isCounting ? `${this.countdown} 秒后重试` : '获取验证码';
			},

			// 判断手机号是否合法（简单校验）
			isPhoneValid3() {
				return util.checkPhone(this.form3.mobile);
			},
			// 按钮显示文字
			buttonText3() {
				return this.isCounting3 ? `${this.countdown3} 秒后重试` : '获取验证码';
			},
			
			dialogVisible() {
			  return this.$store.state.showlogin
			}

		},

		methods: {
			...mapMutations(["setToken", "setUserInfo", "logout"]),
			closedlg(){
				this.$store.commit("closelogin")
			},
			opendlg(){
				this.$store.commit("openlogin")
			},
			captcha(){
				ty.ajax("web/admin/login/captcha", {}).then((d)=>{
					this.codeImg = 'data:image/png;base64,' + d.data.image
					this.form.uuid = d.data.uuid
				})
			},
			tobind(n){
				if (n=='wechart'){
					this.$store.commit("closelogin")
					util.tourl('/bindpage/wechart')
				}
				else if (n=='alipay'){
					this.$store.commit("closelogin")
					util.tourl('/bindpage/alipay')
				}
			},
			//登录
			onSubmit_login() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.loading1 = true
						ty.ajax("web/admin/login/login",this.form).then((d)=>{
							util.vmsg('登录成功');
							this.setToken(d.data.auth.access_token)
							this.setUserInfo(d.data)
							setTimeout(()=>{
								//this.dialogVisible = false
								this.closedlg()
								this.$emit("loginok",d.data)
								this.loading1 = false
							},500)
						}).catch(()=>{
							this.loading1 = false
							this.captcha()
						})
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 注册
			onSubmit_register() {
				this.$refs['form2'].validate((valid) => {
					if (valid) {
						this.loading2 = true
						ty.ajax("web/admin/login/register",this.form2).then((d)=>{
							util.vmsg('注册成功');
							setTimeout(()=>{
								this.setToken(d.data.auth.access_token)
								this.setUserInfo(d.data)
								this.closedlg()
								this.$emit("regok",d.data)
								this.loading2 = false
							},500)
						}).catch(()=>{
							this.loading2 = false
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//重置
			onSubmit_reset() {
				this.$refs['form3'].validate((valid) => {
					if (valid) {
						this.loading3 = true
						ty.ajax("web/admin/login/changepw",this.form3).then((d)=>{
							util.vmsg('密码重置成功');
							setTimeout(()=>{
								this.type=1
								this.loading3 = false
							},500)
						}).catch(()=>{
							this.loading3 = false
							this.captcha()
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleClose() {
				this.$refs["form"].resetFields();
				this.$refs["form2"].resetFields();
				this.$refs["form3"].resetFields();
				this.type=1
			},
			text() {
				this.$refs.agreement.dialogVisible = true
			},
			agree(){
				this.checked = true
			},
			handleGetCode() {
				if (!this.isPhoneValid) {
					this.$message.warning('请输入正确的手机号');
					return;
				}

				// 模拟发送验证码请求
				this.$message.success('验证码已发送，请注意查收');

				// 开始倒计时
				this.isCounting = true;
				this.countdown = 60;

				const timer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
					} else {
						clearInterval(timer);
						this.isCounting = false;
					}
				}, 1000);
			},
			//清除表单验证
			clearValidation() {

			},
			handleGetCode3() {
				if (!this.isPhoneValid3) {
					this.$message.warning('请输入正确的手机号');
					return;
				}

				// 模拟发送验证码请求
				this.$message.success('验证码已发送，请注意查收');

				// 开始倒计时
				this.isCounting3 = true;
				this.countdown3 = 60;

				const timer3 = setInterval(() => {
					if (this.countdown3 > 0) {
						this.countdown3--;
					} else {
						clearInterval(timer3);
						this.isCounting3 = false;
					}
				}, 1000);
			}
		},
		mounted() {
			this.captcha()
		}
	};
</script>

<style lang="scss">
	@import "login.scss";
</style>